import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { Invoice } from "../models/invoice-details.model";

@Injectable({ providedIn: 'root' })
export class InvoiceDetailsService {

    private mockInvoiceDetails: Invoice[] = [
        {
            id: '1',
            date: '2025-12-18',
            status: 'Sent',
            user: {
                name: 'John Doe',
                username: 'johndoe',
                userId: '123',
                email: 'john@doe.com',
                address: '123 Road Street, Aarhus 8000',
                phone: '+45 12345678',
                plantId: '321',
                subscriptionType: 'Premium',
                hubspotId: '6879',
                tracelinkId: '9876'
            },
            items: [
                { description: 'Opladninger', quantity: 100, unit: 'kWh', unitPrice: -0.80, totalPrice: -80.00 },
                { description: 'Afladninger', quantity: 100, unit: 'kWh', unitPrice: 1.60, totalPrice: 160.00 },
                { description: 'Abonnementsfradrag', quantity: 1, unit: '', unitPrice: null, totalPrice: -64.80 }
            ],
            subtotal: 15.20,
            vat: 3.80,
            total: 19.00,
            vatFree: 0,
            vatAmount: 15.20
        },
        {
            id: '2',
            date: '2025-12-10',
            status: 'Failed',
            user: {
                name: 'Jane Smith',
                username: 'janesmith',
                userId: '456',
                email: 'jane@smith.com',
                address: '123 Road Street, Aarhus 8000',
                phone: '+45 12345678',
                plantId: '321',
                subscriptionType: 'Premium',
                hubspotId: '6879',
                tracelinkId: '9876'
            },
            items: [
                { description: 'Opladninger', quantity: 100, unit: 'kWh', unitPrice: -0.80, totalPrice: -80.00 },
                { description: 'Afladninger', quantity: 100, unit: 'kWh', unitPrice: 1.60, totalPrice: 160.00 },
                { description: 'Abonnementsfradrag', quantity: 1, unit: '', unitPrice: null, totalPrice: -64.80 }
            ],
            subtotal: 15.20,
            vat: 3.80,
            total: 19.00,
            vatFree: 0,
            vatAmount: 15.20
        },
        {
            id: '3',
            date: '2025-12-10',
            status: 'Pending',
            user: {
                name: 'Alice Johnson',
                username: 'alicejohnson',
                userId: '789',
                email: 'alice@johnson.com',
                address: '123 Road Street, Aarhus 8000',
                phone: '+45 12345678',
                plantId: '321',
                subscriptionType: 'Premium',
                hubspotId: '6879',
                tracelinkId: '9876'
            },
            items: [
                { description: 'Opladninger', quantity: 100, unit: 'kWh', unitPrice: -0.80, totalPrice: -80.00 },
                { description: 'Afladninger', quantity: 100, unit: 'kWh', unitPrice: 1.60, totalPrice: 160.00 },
                { description: 'Abonnementsfradrag', quantity: 1, unit: '', unitPrice: null, totalPrice: -64.80 }
            ],
            subtotal: 15.20,
            vat: 3.80,
            total: 19.00,
            vatFree: 0,
            vatAmount: 15.20
        }
    ];

    getInvoiceDetailsById(id: string): Observable<Invoice | undefined> {
        return of(this.mockInvoiceDetails.find(i => i.id === id));
    }
}